module.exports = __webpack_public_path__ + "static/media/icon3.ba52c8a3.png";